import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import useAuthStore from '@zet/feature-user/store/authStore'
import { i18n } from '@zet/localization'

import { storeToken, verifyOtp } from '../functions'

function useVerifyOtp() {
  const { setIsAuthenticated, setAuthToken } = useAuthStore((store) => store)

  const toast = useToast()

  return useMutation(verifyOtp, {
    async onSuccess(data) {
      const { action, error, jwtToken } = data.data
      if (error) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: error,
          hideAfter: 3000,
        })
      } else {
        storeToken(jwtToken, action)
        setAuthToken(jwtToken)
        setIsAuthenticated(true)
      }
    },
    onError(error) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description:
          error?.response?.data?.error ||
          i18n.t('toastMessages.tryAfterSometime'),
        hideAfter: 3000,
      })
    },
  })
}

export { useVerifyOtp }
